<template>
  <div>
    <div class="contact">
      <div class="comtact-bgc">
        <p>{{$t("i.contacts.title")}}</p>
      </div>
      <div class="technical-research">
        <p>{{(contactsData.title)}}</p>
      </div>
      <div class="ministry-of-law">
        <p>{{(contactsData.person_name)}}</p>
      </div>
      <div class="phone">
        <template v-for="nav in contactsData.phones" >
          <img src="../../../../static/indexImg/phone.png" class="icon-phg">
          <p>{{nav}}</p><br>
        </template>
      </div>
      <div class="email">
        <template v-for="email in contactsData.emails" >
          <img src="../../../../static/indexImg/Email.png" class="icon-phg">
          <p class="email-text1">{{email}}</p><br>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "contacts",
      props: {
        contactsData: {
        }
      },
      data(){
        return{

        }
      },
    }
</script>

<style scoped>
  .contact{
   /* margin-top: -80px;*/
    width: 290px;
    height: 443px;
    border: 1px solid #000;
    float: left;
    border-radius: 10px;
    background-color: #fff;
  }
  .comtact-bgc{
    width: 290px;
    height: 40px;
    background-color: #464646;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .comtact-bgc p{
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    color: #fff;
  }
  .ministry-of-law{
    margin: 10px 0 0 20px;
  }
  .ministry-of-law p{
    font-size: 20px;
  }
  .phone{
    margin: 12px 0 0 20px;
  }
  .phone p{
    display: inline-block;
    font-size: 20px;
  }
  .email{
    margin: 20px 0 0 20px;
    position: relative;
  }
  .icon-phg{
    width: 20px;
    height: 16px;
  }
  .email p{
    display: inline-block;
    font-size: 12px;
    position: absolute;
    left: 25px;
  }
  .technical-research{
    margin-top: 20px;
  }
  .technical-research p{
    font-size: 16px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/contacts.vue